/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FolderSharedIcon16Light } from './FolderSharedIcon16Light';
import { FolderSharedIcon16Regular } from './FolderSharedIcon16Regular';
import { FolderSharedIcon16Solid } from './FolderSharedIcon16Solid';
import { FolderSharedIcon20Light } from './FolderSharedIcon20Light';
import { FolderSharedIcon20Regular } from './FolderSharedIcon20Regular';
import { FolderSharedIcon20Solid } from './FolderSharedIcon20Solid';
import { FolderSharedIcon24Regular } from './FolderSharedIcon24Regular';
import { FolderSharedIcon24Solid } from './FolderSharedIcon24Solid';
import { FolderSharedIcon32Regular } from './FolderSharedIcon32Regular';
import { FolderSharedIcon64Regular } from './FolderSharedIcon64Regular';
var sizes = {
    16: {
        light: FolderSharedIcon16Light,
        regular: FolderSharedIcon16Regular,
        solid: FolderSharedIcon16Solid,
    },
    20: {
        light: FolderSharedIcon20Light,
        regular: FolderSharedIcon20Regular,
        solid: FolderSharedIcon20Solid,
    },
    24: {
        regular: FolderSharedIcon24Regular,
        solid: FolderSharedIcon24Solid,
    },
    32: {
        regular: FolderSharedIcon32Regular,
    },
    64: {
        regular: FolderSharedIcon64Regular,
    },
};
export var FolderSharedIcon = forwardRef('FolderSharedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
